import './fixes'

// Carrega jQuery
import jquery from 'jquery'

import Vue from 'vue'
import Vuex from 'vuex'
import store from './store/index'
import VueRouter from 'vue-router'
import CustomVeeValidate from './custom-validate'
import vueSmoothScroll from 'vue-smooth-scroll'
import VMdDateRangePicker from "v-md-date-range-picker";

import VueDatePicker from 'vue2-datepicker';
import Cookies from 'js-cookie'

import MMFilterPlugin from './filters'
import MMValidatorPlugin from './validators'
import MMDirectivesPlugin from './directives'
import MMComponentsPlugin from './components'
import Mixin from './vue-mixin'

import {router} from './routes.js'
import config from './config'
import Vue2TouchEvents from 'vue2-touch-events';


import Mobile from './mobile';

import DocumentsEnum from './enum/documents';
import DocumentsService from './services/documents';


// Carrega estilos globais
import './styles/global/index.scss'

// Carrega Javascript do Bootstrap
import 'bootstrap-sass'

Vue.config.errorHandler = function(err, vm) {
  console.error(err);
  console.error("Context:");
  console.error(vm);
};

const configValidator = {
    delay: 500,
    strict: false
};

// Carrega os plugins
Vue.use(CustomVeeValidate, configValidator);
Vue.use(VueRouter);
Vue.use(MMFilterPlugin);
Vue.use(MMValidatorPlugin);
Vue.use(MMDirectivesPlugin);
Vue.use(MMComponentsPlugin);
Vue.use(vueSmoothScroll);
Vue.use(Vue2TouchEvents);
Vue.use(VMdDateRangePicker);
Vue.use(VueDatePicker);
Vue.use(Cookies);
Vue.use(Vuex);
Vue.mixin(Mixin);

// Configura o aplicativo
config.run();

DocumentsService.getDocumentsByInterface(["WEBSITE","MOBILE"]).then(res => {
  if (res.status.code == 0) {
    DocumentsEnum.push(...res.ListDoc);
    Object.freeze(DocumentsEnum);

    new Vue({
      router,
      store
    }).$mount('#app');
  } else {
    console.error("Falha ao carregar documentos. Código:", res.status.code);
  }
}).catch(err => {
  console.error("Erro na requisição dos documentos:", err);
  new Vue({
    router,
    store
  }).$mount('#app');});

window.$mobile = Mobile;



// WEBPACK FOOTER //
// ./src/main.js